import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import style from "./style";
import { LoadingButton } from "@mui/lab";
import Modal from "../../components/Modal";
import { ReactComponent as Delete } from "../../assets/invoice/redDelete.svg";
const PensionPage = ({
  loading,
  handleDeletePension,
  handlePension,
  pensions,
  handleCreatePension
}) => {
  const [allowance, setAllowance] = useState();
  const [allowanceText,setAllowanceText]=useState(false)
  // const [allowanceTax, setAllowanceTax] = useState(false);
  const [from, setFrom] = useState("");
  const [leave, setLeave] = useState("");
  // const [editleave, setEditleave] = useState("");
  const [open, setOpen] = useState(false);
  const [isPaid,setIsPaid]=useState(false)
  const [value, setValue] = useState();
  const [dltAllowance, setDelAllowance] = useState(false);
  const [allowanceTax, setAllowanceTax] = useState([
    { taxable: false },
    { taxable: true },
    // Add more items as needed
  ]);
  // const [checkbox,setCheckbox]=useState(false)
  const handleAddLeaveType = () => {
    setOpen(true);
    setFrom("create");
    setLeave("");
  };
    
  const deleteData = (item) => {
    setValue(item)
  }
    
    
  const handleDeleteItem = () => {
    handleDeletePension(value);
    setDelAllowance(false);
  }

  console.log(allowance,"allowance---")
  return (
    <>
      {/* <Box sx={style.reportGrid}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Allowances</Typography>
        </Box>
      </Box> */}
      <>
        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Pension</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 2,
            marginRight: 2,
          }}
        >
          <Button
            variant="contained"
            type="submit"
            color="success"
            sx={style.jobButtons}
            onClick={handleAddLeaveType}
          >
            + Add
          </Button>
        </Box>
        <Grid container sx={style.mainContainer}>
          {pensions?.map((allowanceItem, index) => (
            <Grid item xs={12} lg={4} sx={style.gridbox} key={index}>
              <Grid container sx={style.gridContiner}>
                <Grid item xs={12} lg={12}>
                  <Box sx={style.inputSection}>
                    <Box  sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                      <InputLabel sx={style.labels}>Pension Type</InputLabel>
                      <Box 
                        sx={{ ...style.delete, display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }} 
                        onClick={() => { deleteData(allowanceItem?._id); setDelAllowance(true); }}
                      >
                        <Delete />
                      </Box>
                    </Box>
                    <Box sx={style.selectGrid}>
                      <TextField
                        value={allowanceItem.name || ""}
                        onChange={(e) => {
                          const updatedAllowances = [...pensions];
                          updatedAllowances[index].name = e.target.value; 
                          setAllowance(updatedAllowances); 
                          setAllowanceText(e.target.value)
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={12}>
                  <Box sx={style.inputSection}>
                    <FormControlLabel
                      sx={style.formControlLabel}
                      control={
                        <Checkbox
                          checked={allowanceItem.taxable || false}
                          onChange={(e) => {
                            const updatedAllowances = [...pensions];
                            updatedAllowances[index].taxable = e.target.checked; 
                            setAllowanceTax(updatedAllowances); 
                          }}
                        />
                      }
                      label="Is Taxable"
                    />
                  </Box>
                </Grid>
                <Box sx={{ ...style.btnSection, width: "100%" }}>
                  <Box sx={{ ...style.btnPdf, textAlign: "right" }}>
                    <LoadingButton
                      variant="contained"
                      // disabled={!allowance}
                      onClick={() =>
                        handlePension(
                          allowanceText,
                          allowanceTax,
                          allowanceItem._id
                        )
                      }
                      type="submit"
                      color="primary"
                      sx={style.submitButton}
                    >
                      Save
                    </LoadingButton>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          ))}
        </Grid>

        <Modal
          open={open}
          loading={loading}
          setOpen={setOpen}
          btnText={"Add New"}
          title={"Pension Type"}
          handleCheck={() => {
            {handleCreatePension(leave, isPaid),setOpen(false)}   
          }}
        >
          <Box sx={style.popupBox}>
            <Typography>
              {from === "edit" ? "Add Pension Type" : "Add Pension Type"}
            </Typography>
            <TextField
              sx={style.modalInput}
              name="leave"
              value={leave}
              onChange={(e) => setLeave(e.target.value)}
            />
            <FormControlLabel
              control={<Checkbox />}
              checked={isPaid}
              onChange={(e) => setIsPaid(e.target.checked)}
              label="isPaid"
            />
          </Box>
        </Modal>

        <Modal open={dltAllowance} setOpen={setDelAllowance} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Pension Type"} handleDelete={handleDeleteItem}>
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>
      </>
    </>
  );
};

export default PensionPage;
